<div style="margin-top: -36px;margin-bottom: 50px;" *ngIf="config">
    <div class="container-fluid landing">
        <div class="shipping-info__container" [style.background-image]="'url(' + config.background + ')'">

            <h4 class="shipping-info__header text-white" *ngIf="config.title">
                {{config.title}}
            </h4>

            <div class="shipping-info__search">

                <div class="input-group shipping-info__search--field">
                    <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span>
                    </div>
                    <input id="address-input" #addressInput type="text" (keydown.enter)="searchAdressSubject$.next(addressInput.value)"
                        class="form-control" placeholder="{{config.placeholder}}">
                    <div class="input-group-append">
                        <button class="btn btn-dark" type="button"
                            (click)="searchAdressSubject$.next(addressInput.value)">
                            <i *ngIf="!loadingAvailableShipping" class="fas fa-search"></i>
                            <i *ngIf="loadingAvailableShipping" class="fas fa-circle-notch fa-spin"></i>
                        </button>
                    </div>
                </div>

                <!--<div class="shipping-info__search--progress">
                    <img [attr.hidden]="loadingAvailableShipping ? true : null" src="/assets/images/scooter.gif" width="80" height="85">
                    <img [@startFinish]="animationState" [attr.hidden]="loadingAvailableShipping ? null : true" src="/assets/images/scooter.png" width="80" height="85">
                </div>-->

            </div>
        </div>
    </div>
</div>

<ng-template #modal>
    <div class="quickview">
        <div style="position: absolute; top: 0; bottom: 0; right: 1px;">
            <button style="position: sticky" class="quickview__close" type="button" appClick (click)="modalRef.hide()">
                <app-icon name="cross-20" size="20"></app-icon>
            </button>
        </div>

        <div class="card">
            <div class="card-header">
                <h6>Spedizioni disponibili per: {{currentShownAddress.citta}} ({{currentShownAddress.prov}}) - {{currentShownAddress.cap}}</h6>
            </div>
            <div class="card-table" [ngClass]="{'loading': spinnerLoading}">
                <div class="table-responsive-sm">
                    <table>
                        <thead>
                            <tr>
                                <th>Spedizione</th>
                                <th>Costo</th>
                                <th>Valida per spesa</th>
                                <th>Tempo di spedizione</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="!spinnerLoading">
                                <ng-container *ngIf="getTypesAvailable() as types">
                                    <ng-container *ngFor="let type of types">
                                        <tr *ngFor="let spedizione of spedizioni[type]; let i=index">
                                            <td *ngIf="i == 0" [attr.rowspan]="spedizioni[type].length">{{spedizione.tipoSpedizione}}</td>
                                            <td style="padding-left: 12px" *ngIf="spedizione.percentuale">{{spedizione.percentuale}}% del carrello </td>
                                            <td style="padding-left: 12px" *ngIf="!spedizione.percentuale && spedizione.prezzo">{{spedizione.prezzo | currencyFormat}}</td>
                                            <td style="padding-left: 12px" *ngIf="!spedizione.prezzo">Gratis</td>
                                            <td>Da {{spedizione.min_ordine | currencyFormat}} a {{spedizione.max_ordine | currencyFormat}}</td>
                                            <td>{{spedizione.tempo}}</td>
                                        </tr>
                                    </ng-container>
                                    <tr *ngIf="types.length == 0">
                                        <td colspan="4" style="text-align: center;">Nessuna spedizione disponibile. Se pensi sia un errore o vuoi aggiungere la tua città/paese, contattaci e saremo lieti di aiutarti!</td>
                                    </tr>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="spinnerLoading">
                                <tr *ngFor="let i of [1,2,3]">
                                    <td *ngFor="let j of [1,2,3,4]">
                                        <shimmer type="rect" height="30px"></shimmer>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <span style="color: gray; display: block; margin-bottom: 5px; margin-top: 15px; text-align:center">
            In caso la posizione non è corretta, correggila, cliccando sulla mappa
        </span>
        <div id="google_map"></div>
    </div>
</ng-template>
